module.exports = __webpack_public_path__ + "img/bj1.69185a0f.png";